<div class="modal-content" style="
    border: solid 1px #aaaaaa;
    padding: 10px;
    height: auto !important;

    border-radius: 0 !;
    overflow:auto !important;
  ">
  <div class="modal-body" style="padding: 15px; text-align: center">
    <p style="text-align: center; margin-bottom: 4.9% !important">
      <span style="color: #606060"><strong><span style="font-size: 22px">Introducing direct
            login!</span></strong></span>
    </p>
    <p style="text-align: center; margin-bottom: 5% !important">
      <span style="font-size: 22px"><span style="color: #606060">You can now go directly to your map from
          <a [href]="url">{{url}}</a>. If you have
          more than one map, you will be taken to the one last used.</span>
      </span>
    </p>
    <p style="text-align: center">
      <strong><span style="font-size: 22px">
          <span style="color: #606060">Would you like to enable going directly to your map upon
            login?</span>
        </span></strong>
    </p>

    <p style="text-align: center">&nbsp;</p>
    <p style="text-align: center;margin-bottom: 0 !important;">
      <input (click)="submit()" id="direct_confirmation" name="direct_confirmation" type="button" value="Confirm" />
      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      <input (change)="onChange($event)" name="direct_map" type="radio" value="true" />&nbsp;Yes&nbsp;
      &nbsp; &nbsp;&nbsp;
      <input (change)="onChange($event)" checked="checked" name="direct_map" type="radio" value="false"
        [checked]=true />&nbsp;No
    </p>
    <div style="
        margin-top: 10%;
        text-align: center;
        font-size: 17px;
        color: #606060;
      " class="footer-text">
      This can be changed at any time by going to
      <a href="/dashboard/">My Account</a> in the upper right corner of the map.
      Once there, on the Maps tab, you can toggle this feature on or off.
    </div>
  </div>
</div>